import ControlledInput from "../components/ControlledInput";

const FormPage =({})=> {
    return(
        <ControlledInput/>
    )
}

export default FormPage;